import { useEffect } from 'react';
import { useIteroBrowserRoute } from '../itero-browser/useIteroBrowserRoute';
import { shouldDropBrowseParams, type BrowseRouteGate } from './iteroBoxActions';

export interface IteroBrowseLauncher {
    isOpen: boolean;
    open: () => void;
    close: () => void;
}

type LauncherAccess = Omit<BrowseRouteGate, 'hasParams' | 'isRouteOpen'>;

// ?itero= only opens the browser while this box is mounted; params it can't honour are dropped.
export function useIteroBrowseLauncher(access: LauncherAccess): IteroBrowseLauncher {
    const { route, hasParams, open, close, replace } = useIteroBrowserRoute();
    const isRouteOpen = route !== null;
    const shouldDrop = shouldDropBrowseParams({ ...access, hasParams, isRouteOpen });

    useEffect(() => {
        if (shouldDrop) replace(null);
    }, [shouldDrop, replace]);

    return { isOpen: isRouteOpen && access.canBrowse, open, close };
}
